module.exports = __webpack_public_path__ + "img/Dantam Bridal 26.a2b0ed00.jpg";